import { render, staticRenderFns } from "./ItemPreviewCard.vue?vue&type=template&id=590e4d1e&"
import script from "./ItemPreviewCard.vue?vue&type=script&lang=js&"
export * from "./ItemPreviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "2ce10abc"
  
)

/* custom blocks */
import block0 from "./ItemPreviewCard.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports